import {
  DashboardWidgetDetailType,
  DashboardWidgetType,
} from '@akin-home/dashboards';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import Checkbox from 'expo-checkbox';
import styled from 'styled-components/native';

interface Props {
  widget_option: DashboardWidgetDetailType;

  /** Whether the tile is currently selected */
  selected?: boolean;

  onPress?(type: DashboardWidgetType): void;

  onPressWatchVideo?(video_url: string): void;
}

/** A tile to be displayed in the HomeScreenSetup screen */
export const WidgetOptionTile = (props: Props) => {
  const {
    widget_option: {
      type,
      title,
      color,
      icon_color,
      icon,
      description,
      required,
      video_url,
    },
    selected,
    onPress,
    onPressWatchVideo,
  } = props;

  /** Only handle the onPress if not required */
  const handlePress = () => !required && onPress?.(type);

  const handleVideoPress = () => video_url && onPressWatchVideo?.(video_url);

  const is_selected = !!selected || required;

  return (
    <TileContainer
      onPress={handlePress}
      active={is_selected}
      disabled={required}
    >
      <TitleRow>
        <IconWrapper color={color}>
          <FontAwesomeIcon icon={icon} color={icon_color} size={20} />
        </IconWrapper>

        <CheckboxContainer>
          {required ? (
            <RequiredText weight="semibold">Required*</RequiredText>
          ) : null}
          <RoundCheckbox
            value={is_selected}
            color={is_selected ? colors.primary[70] : undefined}
          />
        </CheckboxContainer>
      </TitleRow>

      <Title weight="semibold">{title}</Title>

      <Description>{description}</Description>

      {video_url && onPressWatchVideo ? (
        <WatchVideoButton onPress={handleVideoPress}>
          <Text weight="semibold">Watch video</Text>
        </WatchVideoButton>
      ) : null}
    </TileContainer>
  );
};

const TileContainer = styled.TouchableOpacity<{ active?: boolean }>`
  width: 280px;
  max-width: 100%;
  aspect-ratio: 1.36;
  border-radius: 15px;
  padding: 16px;

  border-width: 2px;
  border-color: lightgrey;

  ${({ active }) =>
    active
      ? `
  border-color: ${colors.primary[70]};
  background-color: rgba(245, 247, 249, 1);
  `
      : undefined}
`;

const TitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Text)`
  font-size: 20px;
`;

const Description = styled(Text)`
  font-size: 15px;
`;

const WatchVideoButton = styled.TouchableOpacity`
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;

  padding: 12px;
  border-radius: 15px;

  background-color: #051633;

  height: 42px;
`;

const CheckboxContainer = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const RoundCheckbox = styled(Checkbox)`
  border-radius: 50px;
`;
const RequiredText = styled(Text)`
  font-size: 15px;
  color: grey;
`;

const IconWrapper = styled.View<{ color: string }>`
  height: 40px;
  width: 40px;
  border-radius: 100px;

  background-color: ${({ color }) => color};

  align-items: center;
  justify-content: center;
`;
